<script lang="ts">
	import { Button, Container } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import SelectGatewaysStep from 'src/components/Devices/DeviceWizard/AddEditSteps/SelectGatewaysStep.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { Device } from 'src/types/Device';

	export let device: Device;

	let requestLoader = false;
	let gatewayDisableNext = false;
	let SelectGatewaysStepComponent;

	const onSave = async () => {
		if (gatewayDisableNext || !SelectGatewaysStepComponent) return;
		requestLoader = true;
		try {
			await SelectGatewaysStepComponent.updateGatewaysList();
		} finally {
			requestLoader = false;
		}
	};

	$: isSaveDisabled = requestLoader || gatewayDisableNext;
</script>

{#if $showNewLayout}
	<SelectGatewaysStep
		bind:this={SelectGatewaysStepComponent}
		associatedDevice={device}
		bind:gatewayDisableNext
	/>

	<div class="mt-m">
		<Button
			class="width-sm-full"
			variant="primary"
			size="m"
			responsiveSize={{ sm: 'm' }}
			loading={requestLoader}
			disabled={isSaveDisabled}
			icon="fas fa-save"
			on:click={onSave}
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	</div>
{:else}
	<Container type="borderSolid" backgroundColor="color-base">
		<SelectGatewaysStep
			bind:this={SelectGatewaysStepComponent}
			associatedDevice={device}
			bind:gatewayDisableNext
		/>

		<div class="mt-l">
			<Button
				class="width-sm-full"
				variant="primary"
				size="m"
				responsiveSize={{ sm: 'm' }}
				loading={requestLoader}
				disabled={isSaveDisabled}
				icon="fas fa-save"
				on:click={onSave}
			>
				{$format('button_save', { default: 'Save' })}
			</Button>
		</div>
	</Container>
{/if}
